$('body').on('click', '.cookie_box h3', function(e) {
    $('.cookie_box').find('.cookie_rte').stop().slideUp('fast');
    $(this).closest('.cookie_box').find('.cookie_rte').stop().slideToggle('fast');
    $('.cookie_box h3').not(this).removeClass('active');
    $(this).toggleClass('active');
});


document.addEventListener("DOMContentLoaded", function() {

  const STORAGE_KEY = "cookie_preferences";

  // Show modal
  function showModal() {
    const modal = document.getElementById("cookie-consent-modal");
    modal.classList.remove("hidden");
    modal.style.display = "flex";
  }

  // Hide modal
  function hideModal() {
    const modal = document.getElementById("cookie-consent-modal");
    modal.style.display = "none";
    modal.classList.add("hidden");
  }



  // Load saved preferences
  function loadPreferences() {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        const prefs = JSON.parse(saved);
        document.querySelectorAll(".cookie-option").forEach(input => {
          const cat = input.dataset.category;
          if (prefs[cat] !== undefined) {
            input.checked = prefs[cat];
          }
        });
      } catch (e) {
        console.error("Invalid cookie prefs", e);
      }
    } else {
      // Only show if never saved
      showModal();
    }
  }

  // Save preferences
  function savePreferences() {
    const prefs = {};
    document.querySelectorAll(".cookie-option").forEach(input => {
      const cat = input.dataset.category;
      prefs[cat] = input.checked;
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    hideModal();
    applyPreferences();
  }

  // Decline all except strict
  function declineAll() {
    document.querySelectorAll(".cookie-option").forEach(input => {
      if (!input.disabled) {
        input.checked = false;
      }
    });
    savePreferences();
  }

  // Apply preferences (conditionally load scripts)
  function applyPreferences() {
    const prefs = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    if (prefs.analytics) {
      console.log("Analytics scripts allowed");
    }
    if (prefs.marketing) {
      console.log("Marketing scripts allowed");
    }
    if (prefs.functional) {
      console.log("Functional cookies allowed");
    }
  }

  // Event listeners
  document.getElementById("save-cookie-preferences").addEventListener("click", savePreferences);
  document.getElementById("cookie-decline").addEventListener("click", declineAll);
  document.getElementById("cookie-decline2").addEventListener("click", declineAll);
  document.getElementById("manage-cookie-btn").addEventListener("click", showModal);

  // Init
  loadPreferences();
  if (localStorage.getItem(STORAGE_KEY)) {
    applyPreferences();
  }
});





//
 function toggleDiv() {
    var div = document.getElementById("preferences_info");
    if (div.style.display === "none" || div.style.display === "") {
      div.style.display = "block";
    } else {
      div.style.display = "none";
    }

    var div = document.getElementById("cookie_box");
    if (div.style.display === "none" || div.style.display === "") {
      div.style.display = "none";
    } else {
      div.style.display = "block";
    }


    
  }

  document.getElementById("close_preferences").addEventListener("click", function () {
    const modal = document.getElementById("cookie-consent-modal");
  modal.style.display = "none";
});

